import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "wanted_cookie_consent_v1";

export default function CookieBanner() {
  const [choice, setChoice] = useState(() => {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return "set";
    }
  });

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ choice: value, ts: new Date().toISOString() }));
    } catch {}
    setChoice(value);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[90] bg-[#0a0a0c]/95 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_20px_60px_rgba(0,0,0,0.8)]"
          role="dialog"
          aria-label="Consenso cookie"
        >
          <div className="flex items-center gap-3 mb-3">
            <Cookie size={18} className="text-red-500" />
            <p className="font-display font-bold uppercase tracking-tight text-white text-sm">Cookie sobri, promesso</p>
          </div>
          <p className="text-xs text-zinc-400 leading-relaxed">
            Usiamo solo cookie tecnici per login e carrello. Niente pubblicità, niente profilazione. Dettagli nella{" "}
            <Link to="/cookie" data-testid="cookie-banner-policy-link" className="text-red-400 underline underline-offset-2">Cookie Policy</Link>.
          </p>
          <div className="flex gap-3 mt-5">
            <button
              data-testid="cookie-accept-button"
              onClick={() => decide("accepted")}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white font-display font-bold uppercase tracking-wide text-xs px-4 py-3 rounded-full transition-all active:scale-[0.97]"
            >
              Accetta
            </button>
            <button
              data-testid="cookie-reject-button"
              onClick={() => decide("rejected")}
              className="flex-1 border border-white/20 hover:border-white/40 text-zinc-300 font-display font-bold uppercase tracking-wide text-xs px-4 py-3 rounded-full transition-all active:scale-[0.97]"
            >
              Solo tecnici
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
